import colors from './colors';

export default {
  dark: true,
  colors: {
    'surface-secondary': colors.silver.dark25,
    'surface-primary': colors.silver.dark10,
    'surface-overlay': colors.alpha.dark800,
    'surface-inverse': colors.silver.dark900,
    'surface-elevated': colors.silver.dark25,
    'status-warning-surface': colors.yellow.dark600,
    'status-warning-line': colors.yellow.dark500,
    'status-warning-fill-hover': colors.yellow.dark200,
    'status-warning-fill': colors.yellow.dark50,
    'status-warning-content': colors.yellow.dark900,
    'status-success-surface': colors.green.dark600,
    'status-success-line': colors.green.dark500,
    'status-success-fill-hover': colors.green.dark200,
    'status-success-fill': colors.green.dark50,
    'status-success-content': colors.green.dark900,
    'status-progress-surface': colors.sky.dark600,
    'status-progress-line': colors.sky.dark500,
    'status-progress-fill-hover': colors.sky.dark200,
    'status-progress-fill': colors.sky.dark50,
    'status-progress-content': colors.sky.dark900,
    'status-info-surface': colors.silver.dark600,
    'status-info-line': colors.silver.dark500,
    'status-info-fill-hover': colors.silver.dark200,
    'status-info-fill': colors.silver.dark50,
    'status-info-content': colors.silver.dark900,
    'status-indication-surface': colors.red.dark700,
    'status-indication-line': colors.red.dark700,
    'status-indication-fill-hover': colors.red.dark200,
    'status-indication-fill': colors.red.dark50,
    'status-indication-content': colors.red.dark900,
    'status-danger-surface': colors.red.dark700,
    'status-danger-line': colors.red.dark700,
    'status-danger-fill-hover': colors.red.dark200,
    'status-danger-fill': colors.red.dark50,
    'status-danger-content': colors.red.dark900,
    'page-primary': colors.gray.dark0,
    'other-teal-surface': colors.teal.dark600,
    'other-teal-line': colors.teal.dark500,
    'other-teal-fill-hover': colors.teal.dark200,
    'other-teal-fill': colors.teal.dark50,
    'other-teal-content': colors.teal.dark950,
    'other-purple-surface': colors.purple.dark600,
    'other-purple-line': colors.purple.dark500,
    'other-purple-fill-hover': colors.purple.dark200,
    'other-purple-fill': colors.purple.dark50,
    'other-purple-content': colors.purple.dark950,
    'other-pink-surface': colors.pink.dark600,
    'other-pink-line': colors.pink.dark500,
    'other-pink-fill-hover': colors.pink.dark200,
    'other-pink-fill': colors.pink.dark50,
    'other-pink-content': colors.pink.dark950,
    'other-lime-surface': colors.lime.dark600,
    'other-lime-line': colors.lime.dark500,
    'other-lime-fill-hover': colors.lime.dark200,
    'other-lime-fill': colors.lime.dark50,
    'other-lime-content': colors.lime.dark950,
    'other-lemon-surface': colors.lemon.dark600,
    'other-lemon-line': colors.lemon.dark500,
    'other-lemon-fill-hover': colors.lemon.dark200,
    'other-lemon-fill': colors.lemon.dark50,
    'other-lemon-content': colors.lemon.dark950,
    'other-indigo-surface': colors.indigo.dark600,
    'other-indigo-line': colors.indigo.dark500,
    'other-indigo-fill-hover': colors.indigo.dark200,
    'other-indigo-fill': colors.indigo.dark50,
    'other-indigo-content': colors.indigo.dark950,
    'other-cyan-surface': colors.cyan.dark600,
    'other-cyan-line': colors.cyan.dark500,
    'other-cyan-fill-hover': colors.cyan.dark200,
    'other-cyan-fill': colors.cyan.dark50,
    'other-cyan-content': colors.cyan.dark950,
    'other-chocolate-surface': colors.chocolate.dark600,
    'other-chocolate-line': colors.chocolate.dark500,
    'other-chocolate-fill-hover': colors.chocolate.dark200,
    'other-chocolate-fill': colors.chocolate.dark50,
    'other-chocolate-content': colors.chocolate.dark950,
    'line-tertiary-hover': colors.silver.dark300,
    'line-tertiary': colors.silver.dark100,
    'line-selected-hover': colors.blue.dark700,
    'line-selected': colors.blue.dark500,
    'line-secondary-hover': colors.silver.dark500,
    'line-secondary': colors.silver.dark300,
    'line-primary-hover': colors.silver.dark700,
    'line-primary': colors.silver.dark500,
    'line-focus-outline': colors.blue.dark100,
    'line-focus': colors.blue.dark500,
    'line-elevated': colors.alpha.silver400,
    'line-disable': colors.silver.dark200,
    'fill-selected-hover': colors.blue.dark700,
    'fill-selected': colors.blue.dark500,
    'fill-secondary-hover': colors.silver.dark100,
    'fill-secondary-active': colors.silver.dark200,
    'fill-secondary': colors.silver.dark50,
    'fill-primary-hover': colors.silver.dark50,
    'fill-primary-active': colors.silver.dark100,
    'fill-primary': colors.silver.dark10,
    'fill-elevated': colors.silver.dark300,
    'fill-disable': colors.silver.dark50,
    'content-tertiary': colors.silver.dark700,
    'content-secondary': colors.silver.dark800,
    'content-primary': colors.silver.dark950,
    'content-placeholder': colors.silver.dark600,
    'content-on-dark': colors.gray.dark1000,
    'content-link-visited': colors.purple.dark700,
    'content-link': colors.blue.dark700,
    'content-inverse': colors.gray.dark0,
    'content-disable': colors.silver.dark500,
    'brand-secondary-hover': colors.blue.dark50,
    'brand-secondary-border': colors.blue.dark100,
    'brand-secondary-active': colors.blue.dark100,
    'brand-secondary': colors.blue.dark10,
    'brand-primary-hover': colors.blue.dark100,
    'brand-primary-content': colors.blue.dark900,
    'brand-primary-border': colors.blue.dark300,
    'brand-primary-active': colors.blue.dark50,
    'brand-primary': colors.blue.dark300
  },
  variables: {
    'spacing-900': '4rem',
    'spacing-800': '3rem',
    'spacing-700': '2.5rem',
    'spacing-600': '2rem',
    'spacing-500': '1.5rem',
    'spacing-50': '0.125rem',
    'spacing-400': '1rem',
    'spacing-300': '0.75rem',
    'spacing-200': '0.5rem',
    'spacing-1100': '6rem',
    'spacing-1000': '5rem',
    'spacing-100': '0.25rem',
    'shadow-y-minus-400': '0rem',
    'shadow-y-minus-300': '0rem',
    'shadow-y-minus-200': '0rem',
    'shadow-y-minus-100': '0rem',
    'shadow-y-400': '0rem',
    'shadow-y-300': '0rem',
    'shadow-y-200': '0rem',
    'shadow-y-100': '0rem',
    'shadow-x-minus-400': '0rem',
    'shadow-x-minus-300': '0rem',
    'shadow-x-minus-200': '0rem',
    'shadow-x-minus-100': '0rem',
    'shadow-x-400': '0rem',
    'shadow-x-300': '0rem',
    'shadow-x-200': '0rem',
    'shadow-x-100': '0rem',
    'shadow-blur-400': '0rem',
    'shadow-blur-300': '0rem',
    'shadow-blur-200': '0rem',
    'shadow-blur-100': '0rem',
    'font-weight-regular': 400,
    'font-weight-bold': 700,
    'font-size-900': '3.25rem',
    'font-size-800': '2.75rem',
    'font-size-700': '2.25rem',
    'font-size-600': '1.75rem',
    'font-size-500': '1.5rem',
    'font-size-50': '0.625rem',
    'font-size-400': '1.25rem',
    'font-size-300': '1rem',
    'font-size-200': '0.875rem',
    'font-size-1100': '4.5rem',
    'font-size-1000': '3.75rem',
    'font-size-100': '0.75rem',
    'font-line-height-900': '4rem',
    'font-line-height-800': '3rem',
    'font-line-height-700': '2.5rem',
    'font-line-height-600': '2rem',
    'font-line-height-500': '1.75rem',
    'font-line-height-50': '0.75rem',
    'font-line-height-400': '1.5rem',
    'font-line-height-300': '1.25rem',
    'font-line-height-200': '1rem',
    'font-line-height-1100': '5.5rem',
    'font-line-height-1000': '4.5rem',
    'font-line-height-100': '0.875rem',
    'font-letter-spacing-500': '0.0625rem',
    'font-family': 'Arial',
    'border-radius-300': '0.5rem',
    'border-radius-200': '0.25rem',
    'border-radius-100': '0.125rem',
    'border-200': '0.125rem',
    'border-100': '0.0625rem',
    'base-unit': '16px'
  }
};
